import React, { useState } from 'react';
import DrawScoreGate from '@/components/DrawScoreGate';
import { Button } from '@/components/ui/button';

// Public mockup of the draw-scoped Draw Score gate — no auth/data required.
const SAMPLE_CONTRACTORS = [
  { id: 'c1', name: 'Ridgeline Framing LLC', w9_received: true, coi_received: true, coi_expiration: '2027-01-01' },
  { id: 'c2', name: 'Apex Roofing', w9_received: true, coi_received: false },
];

const SAMPLE_PHASES = [
  // Fully ready: W-9, COI, lien, invoice, inspection all done, under budget
  { id: 'p1', name: 'Framing — Ridgeline Framing LLC', phase_type: 'labor', estimated_cost: 42000, actual_cost: 41000, contractor_id: 'c1', lien_waiver_signed: true, has_receipt: true, inspection_passed: true, requires_inspection: true },
  // Needs attention: no COI, no lien waiver, no invoice, over budget with no contingency
  { id: 'p2', name: 'Roofing — Apex Roofing', phase_type: 'labor', estimated_cost: 28000, actual_cost: 30000, contractor_id: 'c2', lien_waiver_signed: false, has_receipt: false },
  // Material line: invoice only, done
  { id: 'p3', name: 'Lumber package — BuildSupply Co', phase_type: 'material', estimated_cost: 15000, actual_cost: 15000, invoice_amount: 15000 },
];

export default function DrawScoreGatePreview() {
  const [open, setOpen] = useState(true);
  const [outcome, setOutcome] = useState('');

  return (
    <div className="min-h-screen bg-slate-100 flex flex-col items-center justify-center p-6 gap-4">
      <div className="text-center max-w-lg">
        <h1 className="text-2xl font-bold text-slate-900">Draw Score gate — preview</h1>
        <p className="text-sm text-slate-500 mt-2">
          This is the readiness check that pops up after you select items in a New Draw Request,
          before the signature &amp; receipt step. Sample data: 1 ready item, 1 with missing docs, 1 material line.
        </p>
        {outcome && <p className="text-sm font-semibold text-emerald-600 mt-3" data-testid="preview-outcome">{outcome}</p>}
        <Button className="mt-4 bg-blue-600 hover:bg-blue-700 text-white" onClick={() => { setOutcome(''); setOpen(true); }} data-testid="reopen-gate-btn">
          Open the Draw Score gate
        </Button>
      </div>

      <DrawScoreGate
        isOpen={open}
        phases={SAMPLE_PHASES}
        contractors={SAMPLE_CONTRACTORS}
        contingencyRemaining={0}
        onClose={() => { setOpen(false); setOutcome('← You tapped "Go back & fix items"'); }}
        onContinue={() => { setOpen(false); setOutcome('✓ Continued to sign & submit'); }}
      />
    </div>
  );
}
